export const ZOOM_STEP = 1.25;
export const MIN_ZOOM = 4;
export const MAX_ZOOM = 15;
export const CENTER = { lat: 39.8283, lng: -98.5795 };
